import { graphql } from '@api/generated';

export const configReviewBannerChangedSubscription = graphql(`
  subscription configReviewBannerChanged {
    configReviewBannerChanged {
      tenantBanners {
        tenantId
        tenantName
        adminReviewStatus
        agentReviewStatus
      }
    }
  }
`);
